import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  MenuItem,
  IconButton,
} from "@mui/material";
import { Post } from "../../services/apiServices";
import { networkUrls } from "../../services/networkurls";
import CloseIcon from "@mui/icons-material/Close";
import constants from "../../utils/constants";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const RaiseTicketModal: React.FC<{
  open: boolean;
  onClose: () => void;
  data: { chatId: number; userMessage: string };
}> = ({ open, onClose, data }) => {
  const [reason, setReason] = useState("");
  const [description, setDescription] = useState("");
  const [errors, setErrors] = useState<{ reason?: string }>({});
  const [loader, setLoader] = useState(false);

  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [countdown, setCountdown] = useState(8);

  const handleSubmit = async () => {
    const newErrors: { reason?: string } = {};
    if (!reason) newErrors.reason = "Reason is required";
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    const payload = {
      reason: reason ,
      description: description ? description : null,
      question: data.userMessage,
      chat_id: data.chatId,
    };

    try {
      setLoader(true);
      const res: any = await Post(networkUrls.raisedQueryTicekt, payload, true);
      if (res.status === 200) {

        // ✅ set message from backend response
        setSuccessMessage(res.data?.message || "Ticket raised successfully.");
        setCountdown(8); // start countdown
      }
    } catch (err) {
      console.error("Error submitting ticket:", err);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (successMessage && countdown > 0) {
      const timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
      return () => clearTimeout(timer);
    } else if (successMessage && countdown === 0) {
      onClose();
       
    }
  }, [successMessage, countdown, onClose]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        

        {!successMessage ? (
          <>
          <IconButton
          onClick={onClose}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>
            <Typography variant="h6" mb={1}>
              Raise a Ticket
            </Typography>
            <Typography variant="body2" color="text.secondary" mb={2}>
              Please select a reason for raising this ticket.
            </Typography>

            <TextField
              select
              label="Reason"
              fullWidth
              margin="normal"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              error={!!errors.reason}
              helperText={errors.reason}
            >
              <MenuItem value="Case study not found in portal">
                Case study not found in portal
              </MenuItem>
              <MenuItem value="Inaccurate Result">Inaccurate Result</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </TextField>

            

            {reason==="Other" && (
              <TextField
                label="Briefly describe the issue"
                fullWidth
                margin="normal"
                multiline
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            )}

            <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
              <Button
                onClick={onClose}
                color="inherit"
                variant="contained"
                disabled={loader}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={loader || !reason}
              >
                {loader ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </>
        ) : (
          // ✅ Success UI with countdown
          <Box textAlign="center">
            <Typography variant="h6" gutterBottom>
              {successMessage}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Redirecting to dashboard in {countdown}
            </Typography>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default RaiseTicketModal;
